import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';
import { PaymentsProps, PaymentsRequest } from './payments.interface';
import { authHeader } from '../../../../../utils/common/authHeader';

export const adminPaymentsApi = createApi({
    reducerPath: 'adminPaymentsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL + '/manager',
        prepareHeaders: (headers: Headers) => authHeader(headers),
    }),
    tagTypes: ['payments'],

    endpoints: build => ({
        readPayments: build.query<
            PaginatedResponse<PaymentsProps>,
            PaymentsRequest
        >({
            query: payload => {
                const queryArgs = qs.stringify(payload.filters, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `payments?${queryArgs}`,
                };
            },
            transformResponse: (res: { data: PaymentsProps[] }, meta) => {
                return {
                    items: res.data || [],
                    total:
                        Number(meta.response.headers.get('Items-count')) || 0,
                };
            },
            providesTags: ['payments'],
        }),
    }),
});

export const { useLazyReadPaymentsQuery } = adminPaymentsApi;
